import axiosAPI from '../../utils/client/axiosAPI';
import { StorageRoomResponse, StorageRoomStorePayload } from './contracts';
import { StorageStand } from './StorageStand';

export class StorageRoom {
  public readonly id: number;
  public readonly name: string;
  public readonly stands: StorageStand[];
  public readonly productsCount: number;

  constructor({
    id,
    name,
    stands = [],
    products_count = 0
  }: StorageRoomResponse) {
    this.id = id;
    this.name = name;
    this.stands = stands.map((s) => new StorageStand(s)); // or [] if not loaded
    this.productsCount = products_count ?? 0;
  }

  static async all(): Promise<StorageRoom[]> {
    const { data } = await axiosAPI.get<StorageRoomResponse[]>(
      '/storage-rooms'
    );
    return data.map((room) => new StorageRoom(room));
  }
  static async get(id: number): Promise<StorageRoom> {
    const { data } = await axiosAPI.get(`/storage-rooms/${id}`);
    return new StorageRoom(data);
  }
  static async store(payload: StorageRoomStorePayload): Promise<StorageRoom> {
    const { data } = await axiosAPI.post('/storage-rooms', payload);
    return new StorageRoom(data);
  }
  async update(payload: StorageRoomStorePayload): Promise<StorageRoom> {
    const { data } = await axiosAPI.put(`/storage-rooms/${this.id}`, payload);
    return new StorageRoom(data);
  }
  async delete() {
    await axiosAPI.delete(`/storage-rooms/${this.id}`);
  }
}
